export const SendPaperIcon = () => {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.44701 11.6003L13.0803 6.61367C13.6203 6.38034 13.6203 5.62034 13.0803 5.387L1.44701 0.400337C1.00701 0.207003 0.520339 0.53367 0.520339 1.007L0.513672 4.08034C0.513672 4.41367 0.760339 4.70034 1.09367 4.74034L10.5137 6.00034L1.09367 7.25367C0.760339 7.30034 0.513672 7.587 0.513672 7.92034L0.520339 10.9937C0.520339 11.467 1.00701 11.7937 1.44701 11.6003V11.6003Z" />
    </svg>
  )
}
